<template>
    <div>
        <footer class="bg-gradient-to-r from-white via-slate-300 to-blue-300 dark:from-gray-900 dark:via-gray-800 dark:to-gray-700">
            <div class="container px-6 py-16 mx-auto">
                <div class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
                    <!-- Company Info -->
                    <div class="space-y-4">
                        <h3 class="text-xl font-bold text-gray-800 dark:text-white">ltenviromonitoring</h3>
                        <p class="text-gray-600 dark:text-gray-300 leading-relaxed">
                            Professional ltenviromonitoring assessment and monitoring services for sustainable development.
                        </p>
                        <div class="flex space-x-4">
                            <!-- Social media icons can be added here -->
                        </div>
                    </div>

                    <!-- Quick Links -->
                    <div class="space-y-4">
                        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Quick Links</h3>
                        <div class="flex flex-col space-y-3">
                            <router-link to="/" 
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Home
                            </router-link>
                            <router-link to="/about" 
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                About Us
                            </router-link>
                            <router-link to="/Service"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Services
                            </router-link>
                            <router-link to="/portfolio"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Portfolio
                            </router-link>
                        </div>
                    </div>

                    <!-- Services -->
                    <div class="space-y-4">
                        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Our Services</h3>
                        <div class="flex flex-col space-y-3">
                            <router-link to="/Service"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Environmental Impact Assessment
                            </router-link>
                            <router-link to="/Service"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Water Quality Monitoring
                            </router-link>
                            <router-link to="/Service"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Air Quality Assessment
                            </router-link>
                            <router-link to="/Service"
                                class="text-gray-600 transition-all duration-300 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:translate-x-1">
                                Waste Management
                            </router-link>
                        </div>
                    </div>

                    <!-- Contact Info -->
                    <div class="space-y-4">
                        <h3 class="text-lg font-semibold text-gray-800 dark:text-white">Contact Us</h3>
                        <div class="flex flex-col space-y-3">
                            <div class="flex items-start space-x-3">
                                <svg class="w-5 h-5 text-blue-600 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                                </svg>
                                <div>
                                    <p class="text-gray-600 dark:text-gray-300">0814342904</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-3">
                                <svg class="w-5 h-5 text-blue-600 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                                </svg>
                                <div>
                                    <p class="text-gray-600 dark:text-gray-300">services@enviroassess.co.za</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bottom Bar -->
                <div class="mt-12 pt-8 border-t border-gray-300 dark:border-gray-600">
                    <div class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div class="text-center md:text-left">
                            <p class="text-gray-600 dark:text-gray-300">
                                &copy; Copyright 2024 ltenviromonitoring. All Rights Reserved.
                            </p>
                        </div>
                        <div class="flex space-x-6 text-sm">
                            <router-link to="#" class="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 transition-colors">
                                Privacy Policy
                            </router-link>
                            <router-link to="#" class="text-gray-600 hover:text-blue-600 dark:text-gray-300 dark:hover:text-blue-400 transition-colors">
                                Terms of Service
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style scoped>
.imgbox {

    border-radius: 5px;
    width: 150px;
    height: 150px;
    display: table-cell;
    object-fit: cover;
}
</style>